import { Button, Card } from 'antd';
import Layout from '../../Layout';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function UnauthorizedPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  return (
    <Layout>
      <div className="w-full min-h-[calc(100vh-140px)] flex items-center justify-center p-4">
        <Card className="w-full max-w-[680px] shadow-sm">
          <h1 className="text-[24px] font-semibold mb-2">{t('unauthorized.title')}</h1>
          <p className="text-[#595959] mb-4">
            {t('unauthorized.description')}
          </p>

          {from && (
            <p className="text-[#8c8c8c] text-sm mb-6">
              {t('unauthorized.blocked_path')}: {from}
            </p>
          )}

          <div className="flex items-center gap-2">
            <Button type="primary" onClick={() => navigate(-1)}>{t('unauthorized.back')}</Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
}
